export default __webpack_public_path__ + "static/media/investmentservice.c024f29b.svg";